module.exports = __webpack_public_path__ + "708781157346f9bcfd5ee5854dde10a3.pdf";